import {
  CART_CREATE_BUSINESS_INFO,
  CART_WIPE_ALL_BUSINESS_INFO,
  CART_ADD_ITEM,
  CART_REMOVE_ITEM,
  CART_INCREASE_QUANTITY,
  CART_DECREASE_QUANTITY,
  SET_CURRENCY,
  CART_ORDER_SUCCESS,
  SET_STRIPE_ORDER_STATUS,
  RESET_STRIPE_ORDER_STATUS,
  CART_REMOVE_ALL_ITEMS
} from '../constants'

type ICartReducer = {
  businessId: string
  items: any[]
  currency: string
  regionId: string
  delivery: boolean
  pickup: boolean
  businessTypeId: number | null
  businessName: string
  isoCode: string
  supportsCashOnDelivery: boolean
  supportsBitcoin: boolean
  supportsMmg: boolean
  supportsCreditCard: boolean
  isStripeOrderDone: boolean
  pickupFee: string
  merchantId: string
  serviceFees: any[]
  taxes: any[]
  subTotal: number
  usesTwoDestinations: boolean
  usesSingleItemCheckout: boolean
  usesBillingPayment: boolean
}

const initialState = {
  businessId: '',
  items: [],
  currency: '',
  regionId: '',
  delivery: false,
  pickup: false,
  businessTypeId: null,
  businessName: '',
  isoCode: '',
  supportsCashOnDelivery: false,
  supportsBitcoin: false,
  supportsMmg: false,
  supportsCreditCard: false,
  isStripeOrderDone: false,
  usesTwoDestinations: false,
  pickupFee: '',
  merchantId: '',
  serviceFees: [],
  taxes: [],
  subTotal: 0,
  usesSingleItemCheckout: false
}

const CartReducer = (
  state: ICartReducer = initialState,
  action
): ICartReducer => {
  switch (action.type) {
    case CART_CREATE_BUSINESS_INFO: {
      return {
        ...state,
        businessId: action.payload.businessId,
        regionId: action.payload.regionId,
        items: []
      }
    }

    case CART_ORDER_SUCCESS:
    case CART_WIPE_ALL_BUSINESS_INFO: {
      return initialState
    }

    case CART_REMOVE_ALL_ITEMS:
      return {
        ...state,
        items: []
      }

    case SET_CURRENCY: {
      return {
        ...state,
        currency: action.payload
      }
    }

    case CART_ADD_ITEM: {
      return {
        ...state,
        ...action.payload
      }
    }
    case CART_REMOVE_ITEM: {
      return {
        ...state,
        items: [
          ...state.items.slice(0, action.payload),
          ...state.items.slice(action.payload + 1)
        ]
      }
    }
    case CART_INCREASE_QUANTITY: {
      let item = state.items[action.payload.index]
      item.quantity = item.quantity + action.payload.quantity

      return {
        ...state,
        items: [
          ...state.items.slice(0, action.payload.index),
          item,
          ...state.items.slice(action.payload.index + 1)
        ]
      }
    }
    case CART_DECREASE_QUANTITY: {
      let item = state.items[action.payload]
      item.quantity = item.quantity - 1

      return {
        ...state,
        items: [
          ...state.items.slice(0, action.payload),
          item,
          ...state.items.slice(action.payload + 1)
        ]
      }
    }

    case SET_STRIPE_ORDER_STATUS:
      return {
        ...state,
        isStripeOrderDone: action.payload
      }

    case RESET_STRIPE_ORDER_STATUS:
      return {
        ...state,
        isStripeOrderDone: false
      }
    default:
      return state
  }
}

export default CartReducer
